<template>
  <div v-if="visible" class="wx-tip-mask" @touchmove.prevent>
    <div class="wx-tip-arrow"></div>
    <div class="wx-tip-card">
      <div class="wx-tip-icon">
        <van-icon name="warning-o" />
      </div>
      <h2 class="wx-tip-title">请在浏览器中打开</h2>
      <p class="wx-tip-desc">为获得最佳直播体验<br />请点击右上角 <strong>···</strong><br />选择「在浏览器中打开」</p>
      <div class="wx-tip-steps">
        <div class="wx-tip-step">
          <span class="step-num">1</span>
          <span>点击右上角 ···</span>
        </div>
        <div class="wx-tip-step">
          <span class="step-num">2</span>
          <span>选择「在浏览器打开」</span>
        </div>
      </div>
      <div class="wx-tip-copy" @click="copyUrl">
        <van-icon name="link-o" />
        <span>{{ copied ? '已复制，请在浏览器粘贴打开' : '复制链接' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'WxOpenTip',
  data() {
    return {
      visible: false,
      copied: false
    }
  },
  methods: {
    show() {
      this.visible = true
      this.copied = false
      document.body.style.overflow = 'hidden'
    },
    hide() {
      this.visible = false
      document.body.style.overflow = ''
    },
    copyUrl() {
      const url = window.location.href
      const fallbackCopy = () => {
        const ta = document.createElement('textarea')
        ta.value = url
        ta.style.position = 'fixed'
        ta.style.left = '-9999px'
        document.body.appendChild(ta)
        ta.select()
        try {
          document.execCommand('copy')
          this.copied = true
          Toast.success('已复制')
        } catch (e) {
          Toast.fail('复制失败')
        }
        document.body.removeChild(ta)
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.copied = true
          Toast.success('已复制')
        }).catch(fallbackCopy)
      } else {
        fallbackCopy()
      }
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.wx-tip-mask {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 16px;
  -webkit-tap-highlight-color: transparent;
}

.wx-tip-arrow {
  width: 60px;
  height: 60px;
  margin-right: 6px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60'%3E%3Cpath d='M30 6 L30 40 M30 6 L20 18 M30 6 L40 18 M20 44 a4 4 0 1 1 8 0 a4 4 0 1 1 -8 0 M32 44 a4 4 0 1 1 8 0 a4 4 0 1 1 -8 0' stroke='%23ffd34e' stroke-width='3' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  align-self: flex-end;
}

.wx-tip-card {
  margin: 24px auto 0;
  width: 90%;
  max-width: 320px;
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 24px;
  text-align: center;
  align-self: center;
}

.wx-tip-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffb547 0%, #ff8f1f 100%);
  color: #fff;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  box-shadow: 0 4px 12px rgba(255, 143, 31, 0.35);
}

.wx-tip-title {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.wx-tip-desc {
  margin: 0 0 18px 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

.wx-tip-desc strong {
  color: #ff8f1f;
  font-weight: 600;
}

.wx-tip-steps {
  text-align: left;
  background: #f7f8fa;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
}

.wx-tip-step {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #303133;
  padding: 6px 0;
}

.step-num {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wx-tip-copy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.wx-tip-copy:active {
  opacity: 0.85;
}
</style>
